var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"iframeBox"},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(!_vm.iframeLoading),expression:"!iframeLoading"}],attrs:{"src":_vm.iframeUrl,"frameborder":"0","height":"100%","width":"100%","id":"iframe"}})]),_vm._v(" "),(_vm.iframeLoading)?_c('Spin',{attrs:{"size":"large","fix":""}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235001ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/TrainManageInfo.vue
// module id = null
// module chunks = 